import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    urlsToNotUse: Array<string>;

    constructor(private authservice: AuthService, private snackBar: MatSnackBar) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        let authToken = this.authservice.getToken();

        if (!localStorage.getItem('X-Device-ID')) {
            localStorage.setItem('X-Device-ID', this.makeid());
        }

        if (authToken) {
            if (request.url.includes(environment.baseApiUrl)) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${authToken}`,
                        "X-Device-Id": localStorage.getItem('X-Device-ID')
                    }
                });
            } else {
                request = request.clone({
                    setHeaders: {
                        "X-Device-Id": localStorage.getItem('X-Device-ID')
                    }
                });
            }
        } else {
            request = request.clone({
                setHeaders: {
                    "X-Device-Id": localStorage.getItem('X-Device-ID')
                }
            });
        }
        // X-Device-ID
        return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
            if (err.status === 401) {
                this.snackBarOnError("Session Expired!");

                setTimeout(() => {
                    this.authservice.doLogout();
                }, 2000);
            }
            if (err.status === 403) {
                this.snackBarOnError("Access Forbidden! Please contact admin to continue");
            }
            if (err.status === 304) {
                this.snackBarOnError("Access Forbidden! Please contact admin to continue");
            }
            return throwError(() => err)
        }));
    }

    snackBarOnError(snack: string) {
        this.snackBar.open(snack, 'Close', {
            verticalPosition: 'top',
            duration: 2000,
        });
    }

    makeid() {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < 256) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        return result;
    }
}
